const moment = require('moment')

export default {
  namespaced: true,
  state: {
    items: [],
    groups: [{
        value: "instruments",
        text: "IM"
      },
      {
        value: "outillage",
        text: "OC"
      },
      {
        value: "service_et_logistique",
        text: "SL"
      }
    ]
  },
  getters: {
    // getAll: state => state.items,
    getByStatusSlug: state => status => state.items.filter(item => {
      if (typeof status === "object") {
        return status.includes(item.status_slug) || status.includes(item.status.status_slug)
      } else {
        return item.status_slug == status || item.status.status_slug == status
      }
    }),
    getItem: state => id => state.items.find(item => item.id == id),
    getGroups: state => state.groups,
    // Les produits importés de MCS portent des codes de service hors nomenclature (D, E, F,
    // L, P) : on renvoie le code tel quel plutôt que undefined, dont les appelants lisent
    // tous le `.text` — c'est ce qui faisait planter le détail et la liste des produits.
    getGroup: state => group => state.groups.find(item => item.value == group) || { value: group, text: group }
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   boolean wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns promise       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'rentingpreparation',
        api_data_path: 'rentingPreparations',
        namespace: 'renting_preparation'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items d'un (ou plusieurs) statut via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   array   status  Status
     * @param   boolean wait    Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns promise         Aucune donnée n'est retournée
     */
    getByStatusSlug: (context, status, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'rentingpreparation/by/status',
        api_data_path: 'rentingPreparations',
        namespace: 'renting_preparation',
        query: 'status=' + status.join('|')
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous MES items d'un (ou plusieurs) statut via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   array   status  Status
     * @param   boolean wait    Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns promise         Aucune donnée n'est retournée
     */
    getMineByStatusSlug: (context, status, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'rentingpreparation/my/by/status',
        api_data_path: 'rentingPreparations',
        namespace: 'renting_preparation',
        query: 'status=' + status.join('|')
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'rentingpreparation',
        namespace: 'renting_preparation',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'rentingpreparation',
        namespace: 'renting_preparation',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    saveItemProducts(context, item) {
      let params = {
        api_url: 'rentingpreparation/partial',
        namespace: 'renting_preparation',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/renting_preparation.js